module.exports = __webpack_public_path__ + "img/shuixi11.f3060946.png";